export default class NavigationMain {
  constructor($navigatioMain, mq) {
    this.$navigatioMain = $navigatioMain;
    this.isDesktop = mq.matches;

    this.bindedOnKeypress = this.onKeypress.bind(this);
    document.addEventListener('keydown', this.bindedOnKeypress);
  }

  onKeypress(event) {
    const $target = event.target;
    let isInside = false;
    // console.log('keyPress', $target);

    if ($target) {
      isInside = $target === this.$navigatioMain || this.$navigatioMain.contains($target);
      // console.log('keyPress isInside', isInside);
    }

    if (isInside) {
      // ESC-Key
      if (event.keyCode === 27) {
        const $activeMainNavItem = this.$navigatioMain.querySelector('.header__navigation-item--main[aria-expanded="true"]');
        const $activeMainNavItemParent = $activeMainNavItem.parentElement;
        const $activeMenu = $activeMainNavItemParent.querySelector('.header__navigation-menu');
        const $activeElement = document.activeElement;
        if ($activeMainNavItemParent.contains($activeElement)) {
          $activeMainNavItem.setAttribute('aria-expanded', 'false');
          $activeMenu.setAttribute('aria-hidden', 'true');
          $activeMainNavItem.focus();
          // $activeMainNavItem.classList.add('focus-visible focus-within');
        }
      }

      // ENTER-Key
      // Commented out due to inconsistency issues with navigation.
      // Please keep this commented-out code here!
      // if (event.keyCode === 13) {
      //   // Target enter-key main menu items
      //   const $activeElement = document.activeElement;

      //   if ($activeElement.classList.contains('header__navigation-item--main')) {
      //     const $adjacentMenu
      //        = $activeElement.parentElement.querySelector('.header__navigation-menu');
      //     const isOpen = $activeElement.getAttribute('aria-expanded');
      //     if (isOpen === 'false') {
      //       $activeElement.setAttribute('aria-expanded', 'true');
      //       $adjacentMenu.setAttribute('aria-hidden', 'false');
      //     } else {
      //       $activeElement.setAttribute('aria-expanded', 'false');
      //       $adjacentMenu.setAttribute('aria-hidden', 'true');
      //     }
      //   }
      // }

      // Right
      if (event.keyCode === 39) {
        const $activeElement = document.activeElement;
        if ($activeElement && $activeElement.classList.contains('header__navigation-item--main')) {
          const $rightsideSibling = $activeElement.parentElement.nextElementSibling || false;
          if ($rightsideSibling) {
            const $rightsideSiblingItem = $rightsideSibling.querySelector('.header__navigation-item--main') || false;
            if ($rightsideSiblingItem) {
              $rightsideSiblingItem.focus();
            }
          }
        }
      }

      // Left
      if (event.keyCode === 37) {
        const $activeElement = document.activeElement;
        if ($activeElement && $activeElement.classList.contains('header__navigation-item--main')) {
          const $leftsideSibling = $activeElement.parentElement.previousElementSibling || false;
          if ($leftsideSibling) {
            const $leftsideSiblingItem = $leftsideSibling.querySelector('.header__navigation-item--main') || false;
            if ($leftsideSiblingItem) {
              $leftsideSiblingItem.focus();
            }
          }
        }
      }
    }
  }
}
